import { render, staticRenderFns } from "./HeaderNav.vue?vue&type=template&id=6b4367e0&scoped=true&"
import script from "./HeaderNav.vue?vue&type=script&lang=js&"
export * from "./HeaderNav.vue?vue&type=script&lang=js&"
import style0 from "./HeaderNav.vue?vue&type=style&index=0&id=6b4367e0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b4367e0",
  null
  
)

export default component.exports